import { Button } from "Components";
import { FlexColumn } from "Components/Flex";
import { Modal } from "Components/Modal";
import { Body1 } from "melodies-source/Text";
import styled from "styled-components";

type ConfirmOptions = {
  hide?: boolean;
  delete?: boolean;
};

interface ConfirmLiveEditProps {
  isOpen?: boolean;
  onClose?: VoidFunction;
  onConfirm?: VoidFunction;
  onHide?: VoidFunction;
  title?: string;
  message?: React.ReactNode;
  options?: ConfirmOptions;
  isHidden?: boolean;
}

export const ConfirmQuestionUpdate = ({
  isOpen,
  onClose,
  onConfirm,
  onHide,
  options,
  title,
  message,
  isHidden,
}: ConfirmLiveEditProps) => {
  return (
    <StyledModal isOpen={isOpen} onClose={onClose} header={title}>
      <Body1>{message}</Body1>
      <ActionsContainer>
        {options?.hide && (
          <Button
            onClick={() => (isHidden ? onClose() : onHide())}
            variant="outlined"
          >
            {isHidden ? "Keep Hidden" : "Hide Instead"}
          </Button>
        )}
        {options?.delete && (
          <Button onClick={onConfirm} variant="destructive">
            Delete
          </Button>
        )}
        <Button onClick={onClose} variant="tertiary">
          Cancel
        </Button>
      </ActionsContainer>
    </StyledModal>
  );
};

const ActionsContainer = styled(FlexColumn)`
  margin-top: 32px;
  gap: 12px;
`;

const StyledModal = styled(Modal)``;
